module.exports = require("./ln-CG");